// ** React Imports
import { useContext } from "react";

// ** Custom Components
import Block from "components/layout/Block";
import PostsSexFilter from "./components/PostsSexFilter";
import PostsPeriodFilter from "./components/PostsPeriodFilter";
import PostsLocationFilter from "./components/PostsLocationFilter";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// #####################################################

const PostsFilters = () => {
	const { isPhone } = useContext(deviceTypeContext);

	return (
		<Block mb={3} mt={3}>
			<Block
				flex
				flexWrap
				alignCenter={!isPhone}
				column={isPhone}
				withRowGap
			>
				<PostsSexFilter />
				<PostsPeriodFilter />
				<PostsLocationFilter />
			</Block>
		</Block>
	);
};

// #####################################################

export default PostsFilters;

// #####################################################
